// extracted by mini-css-extract-plugin
export var fileUpload = "_fy-1";
export var modalButton = "_fy-0";